"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _cssinjs = require("@ant-design/cssinjs");
var _antd = require("antd");
var _react = require("react");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var ConfigContext = _antd.ConfigProvider.ConfigContext;
var makeStyle = function makeStyle(path, styleFn) {
  return function (prefixCls) {
    var _antdTheme$useToken = _antd.theme.useToken(),
      theme = _antdTheme$useToken.theme,
      token = _antdTheme$useToken.token,
      hashId = _antdTheme$useToken.hashId;
    var _useContext = (0, _react.useContext)(ConfigContext),
      getPrefixCls = _useContext.getPrefixCls;
    var rootCls = getPrefixCls();
    return [(0, _cssinjs.useStyleRegister)({
      theme: theme,
      hashId: hashId,
      token: token,
      path: [path, prefixCls || '']
    }, function () {
      return styleFn(_objectSpread(_objectSpread({}, token), {}, {
        rootCls: ".".concat(rootCls),
        componentCls: ".".concat(prefixCls),
        headerHeight: 56
      }));
    }), hashId];
  };
};
var _default = exports.default = makeStyle;